import { useConfig } from "../contexts/ConfigContext"
import { Col,Form,Row, Select, Button, message, Popconfirm, Spin, Modal, Checkbox, CheckboxOptionType, Space } from "antd"
import React, { useEffect, useState } from "react"
import { useRegister } from "../contexts/RegisterContext"
import { contentPath, modules } from "../config/pages"
import { useCompany } from "../contexts/CompanyContext"
import { useSecureRequest } from "../hooks/useSecureRequest";
import { useHistory, useParams } from "react-router-dom"
import RegisterStorageItemForm from "./forms/RegisterStorageItemForm"
import RegisterServiceForm from "./forms/RegisterServiceForm"
import RegisterFixedAssetForm from "./forms/RegisterFixedAssetForm"
import { CheckboxGroupProps } from "antd/es/checkbox"
import InventoryModalData from "./modals/InventoryModalData"
import { defaultStorageItemValues, TElementModuleOptions, TElementPrices, TOhterValues, TStorageItemRS } from "../models/storageModel"
import { useStore } from "../contexts/StoreContext"
import { mutate } from "swr"
import { RollbackOutlined } from "@ant-design/icons"

const checkboxOptions:CheckboxOptionType[] = [
  {label: "Habilitar en compras",value: "PURCHASE"},
  {label: "Habilitar en ventas",value: "SALE"},
]
function getCheckboxOptions(register:{[key:string]:any}){
  const options = []
  if(register.sell_item){
    options.push("SALE")
  }
  if(register.purchase_item){
    options.push("PURCHASE")
  }
  if(!register.uid){
    options.push("SALE","PURCHASE")
  }
  return options
}
function RegisterStorageElement(){
  const history = useHistory()
  const { config, updateConfig } = useConfig()
  const {register,updateRegister} = useRegister()
  const { company } = useCompany()
  const { store } = useStore()
  const {uidItem} = useParams<{uidItem?:string}>()
  const mod = config.module
  let {currentStorageItem} = register
  currentStorageItem = mod === modules.EditStorageItem ? currentStorageItem || defaultStorageItemValues:defaultStorageItemValues
  const { Option } = Select
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [openSuccess, setOpenSuccess] = useState(false)
  const [spinning, setSpinning] = useState(true)
  const [showHeader, setShowHeader] = useState(false)
  const { securePost } = useSecureRequest();

  const [checkedList, setCheckedList] = useState<string[]>(getCheckboxOptions(currentStorageItem));
  const availableItemTypes = register.itemTypes.filter(el => {
    if (mod === modules.EditStorageItem && el.key === currentStorageItem.register_type) {
      return true;
    }
    return el.show === true;
  })
  const availablePresentation = register.displayOptions.find(el => el.show === true)
  const availableCategory = register.categoryOptions.find(el => el.show === true)
  const availableTaxesList = register.taxesOptions.filter(el => el.show === true)
  const [initialDataForm, setInitialDataForm] = useState(toDataForm(currentStorageItem))
  console.log(mod,currentStorageItem)
  const title = mod === modules.EditStorageItem ? "Editar registro " + (currentStorageItem.custom_id || currentStorageItem.uid) : "Crear nuevo Registro"

  useEffect(()=>{
    const loadItemData = async () => {
      if(uidItem){
      setSpinning(true)
      try {
        const itemResponse = await securePost('/inventory/item/get-item',{
          company:company.current?.uid,
          uidItem:uidItem,
          module: config.module
        })
        if(itemResponse.status === 200){
          updateRegister({currentStorageItem:itemResponse.inventoryItem})
          setInitialDataForm(toDataForm(itemResponse.inventoryItem))
          form.setFieldsValue(toDataForm(itemResponse.inventoryItem)) // Ensure form updates
        } else {
          updateRegister({currentStorageItem: defaultStorageItemValues})
          setInitialDataForm(toDataForm({}))
          form.resetFields()
          fail("Producto no encontrado")
        }
      } catch (error: any) {
        console.error("Error loading item:", error);
        fail("Error cargando el producto");
      } finally {
        setSpinning(false)
      }
    } else {
      updateRegister({currentStorageItem: defaultStorageItemValues})
      setInitialDataForm(toDataForm({}))
      form.resetFields()
      setSpinning(false)
    }
  }

    if(mod === modules.EditStorageItem){
      loadItemData()
    }
    const isElement = currentStorageItem.module_options?.find(el => el.sub_type === "TYPE_ELEMENT")?.option_id === availableItemTypes.find(el => el.key === "PRODUCT")?.id
    if(mod === modules.EditStorageItem && isElement){
      setShowHeader(true)
    }
    if(mod === modules.RegisterStorageItem){
      setInitialDataForm(toDataForm({}))
      form.resetFields()
      setSpinning(false)
    }
  },[register.currentStorageItem?.uid, mod, uidItem])
  console.log("Available Item Types: ",availableItemTypes,register.itemTypes)
  // Manejar habilitación de campos
  const register_type = Form.useWatch('register_type', form);
  
  function toDataForm(data:any){
    let copy:any = {}
    //Valor por defecto para servicios
    copy.measure_unit = "UN"
    copy.display = availablePresentation?.key || "UND"
    //-------------------------------
    copy.quantity = 0
    copy.min_quantity = data?.min_quantity ?? 0
    copy.is_traceable = data?.is_traceable !== undefined ? Boolean(data.is_traceable) : (data?.register_type === "FIXED_ASSET")
    const sellDiscountPrice = data?.prices?.find((p: any) => p.type === "SELL_DISCOUNT" || p.type === "DISCOUNT");
    const purchaseDiscountPrice = data?.prices?.find((p: any) => p.type === "PURCHASE_DISCOUNT");
    copy.sell_discount = data?.sell_discount ?? sellDiscountPrice?.value ?? 0;
    copy.purchase_discount = data?.purchase_discount ?? purchaseDiscountPrice?.value ?? 0;
    copy.category = availableCategory?.key || "VRS"
    copy.image = data?.image || ""
    copy.image_mini = data?.image_mini || ""
    copy.images = data?.images || (data?.image ? [{
      file_name: data.name || "Imagen principal",
      file_url: data.image,
      storage_path: "",
      is_primary: true,
      display_order: 0
    }] : [])
    console.log("ToDataFormDtata: ",data)
    if(data.uid){
      copy = {...copy,...data}
      const sellTax = data.module_options?.filter((el:TElementModuleOptions) => el.sub_type === "SELL_TAX") || []
      const purchaseTax = data.module_options?.filter((el:TElementModuleOptions) => el.sub_type === "PURCHASE_TAX") || []
      for(const el of sellTax){
        copy[`sell_taxes_${el.id}`] = register.taxesOptions.find(tax => tax.id === el.option_id)?.key
        copy[`sell_taxes_active_${el.id}`] = el.is_active
      }
      for(const el of purchaseTax){
        copy[`purchase_taxes_${el.id}`] = register.taxesOptions.find(tax => tax.id === el.option_id)?.key
        copy[`purchase_taxes_active_${el.id}`] = el.is_active
      }
      for(const el of data.other_values){
        copy[`otherValues_type_${el.id}`] = el.field_name
        copy[`otherValues_value_${el.id}`] = el.field_value
        copy[`otherValues_visible_${el.id}`] = el.is_visible
      }
    }
    copy.registerOptions = getCheckboxOptions(data)
    return copy
  }

  const getFormTaxes = (values:any, type:"sell" | "purchase") => {
    const arrayTaxes:Partial<TElementModuleOptions>[] = []
    const typeConfig = type === "sell" ? 
    {
      subType: "SELL_TAX",
      activeKey: "sell_taxes_active_",
      searchKey: "sell_taxes_"
    }
    : {
      subType: "PURCHASE_TAX",
      activeKey: "purchase_taxes_active_",
      searchKey: "purchase_taxes_"
    }
    const formVals = { ...values };
    for(const key in formVals){
      if(key.startsWith(typeConfig.searchKey) && !key.includes("active")){
        const taxKey = formVals[key];
        if(taxKey){
          const selectedTaxes = availableTaxesList.find(el => el.key === taxKey)
          if(selectedTaxes) {
            const idStr = key.replace(typeConfig.searchKey, "");
            const isActive = formVals[`${typeConfig.activeKey}${idStr}`];
            const taxItem: Partial<TElementModuleOptions> = {
              sub_type: typeConfig.subType,
              option_id: selectedTaxes.id,
              category: "NATIONAL",
              is_active: isActive !== false
            }
            taxItem.id = Number(idStr)
            taxItem.element_id = register.currentStorageItem?.id
            arrayTaxes.push(taxItem)
          }
        }
      }
    }
    return arrayTaxes
  }
  
  const getOtherValues = (values:any) => {
    const otherValues: Partial<TOhterValues>[] = [];
    // Delete empty keys
    const cleanValues = (obj: any) => {
      for (const key in obj) {
        if (!obj[key]) {
          delete obj[key];
        }
      }
    };

    // Process only key with "_"
    const processUnderscoreKeys = (obj: any) => {
      for (const key in obj) {
        if (!key.includes("_") || !obj[key]) continue;

        if (key.includes("otherValues")) {
          handleOtherValues(key, obj[key], otherValues);
        }

        delete obj[key];
      }
    };

    const handleOtherValues = (key: string, value: any, list: Partial<TOhterValues>[]) => {
      const id = Number(key.split("_").pop()!);
      const type = key.includes("type") ? "field_name" : "field_value";
      const indexOther = list.findIndex(el => el.id === id);
      if (indexOther !== -1 && type === "field_value") {
        list[indexOther][type] = value;
      }

      if (indexOther === -1 && type === "field_name") {
        const visible = values[`otherValues_visible_${id}`] ?? true;
        list.push({ id,element_id:register.currentStorageItem?.id, field_name: value, is_visible: visible })
      }
    };

    cleanValues(values);
    processUnderscoreKeys(values);

    return otherValues.filter(el => el.field_name&&el.field_value);
  }
  const getPrices = (values:any,registerOptions:string[]) => {
    const prices:Partial<TElementPrices>[] = []
    const basePriceItem:Partial<TElementPrices> = {
      element_id: register.currentStorageItem?.id || 0,
      is_default: true,
      is_active: true,
      is_visible: true, 
    }
    const isSale = registerOptions.join("-").includes("SALE")
    const isPurchase = registerOptions.join("-").includes("PURCHASE") || values.register_type === "FIXED_ASSET"
    const existingSell = register.currentStorageItem?.prices?.find(el => el.type === "SELL")
    const existingPurchase = register.currentStorageItem?.prices?.find(el => el.type === "PURCHASE")

    if(isSale){
      if(values.sell_price !== undefined && values.sell_price !== null){
        prices.push({
          ...basePriceItem,
          id: existingSell?.id || -1,
          element_id: register.currentStorageItem?.id,
          type: "SELL",
          value: Number(values.sell_price) || 0,
          description: "Precio de venta",
          is_active: true
        })
      }
    } else if (existingSell?.id) {
      prices.push({
        ...basePriceItem,
        id: existingSell.id,
        element_id: register.currentStorageItem?.id,
        type: "SELL",
        value: Number(existingSell.value) || 0,
        description: "Precio de venta",
        is_active: false
      })
    }

    if(isPurchase){
      if(values.purchase_price !== undefined && values.purchase_price !== null){
        prices.push({
          ...basePriceItem,
          id: existingPurchase?.id || -1,
          element_id: register.currentStorageItem?.id,
          type: "PURCHASE",
          value: Number(values.purchase_price) || 0,
          description: "Precio de compra",
          is_active: true
        })
      }
    } else if (existingPurchase?.id) {
      prices.push({
        ...basePriceItem,
        id: existingPurchase.id,
        element_id: register.currentStorageItem?.id,
        type: "PURCHASE",
        value: Number(existingPurchase.value) || 0,
        description: "Precio de compra",
        is_active: false
      })
    }
    if(values.sell_discount >= 0){
      prices.push({
        ...basePriceItem,
        id: register.currentStorageItem?.prices.find(el => el.type === "SELL_DISCOUNT")?.id || -1,
        element_id: register.currentStorageItem?.id,
        type: "SELL_DISCOUNT",
        value: values.sell_discount,
        description: "Descuento de venta"
      })
    }
    if(values.purchase_discount >= 0){
      prices.push({
        ...basePriceItem,
        id: register.currentStorageItem?.prices.find(el => el.type === "PURCHASE_DISCOUNT")?.id || -1,
        element_id: register.currentStorageItem?.id,
        type: "PURCHASE_DISCOUNT",
        value: values.purchase_discount,
        description: "Descuento de compra"
      })
    }
    return prices
  }
  const getModuleElementOptions = (values:any) => {
    const moduleOptions:Partial<TElementModuleOptions>[] = []
    const categoryKey = values.category || availableCategory?.key || "VRS"
    const displayKey = values.display || availablePresentation?.key || "UND"
    const idCategoryOption = register.categoryOptions.find(el => el.key === categoryKey)?.id
    const idDisplayOption = register.displayOptions.find(el => el.key === displayKey)?.id
    const idItemTypeOption = register.itemTypes.find(el => el.key === values.register_type)?.id
    const idUmOption = register.umOptions.find(el => el.key === values.measure_unit || (values.measure_unit === "UN" && el.key === "UND"))?.id
    if(idCategoryOption){
      moduleOptions.push({
        id: register.currentStorageItem?.module_options?.find(el => el.sub_type === "CATEGORY_ELEMENT")?.id || -1,
        element_id: register.currentStorageItem?.id,
        option_id: idCategoryOption,
        is_active: true,
        sub_type: "CATEGORY_ELEMENT",
        category: "NATIONAL"
      })
    }
    if(idDisplayOption){
      moduleOptions.push({
        id: register.currentStorageItem?.module_options?.find(el => el.sub_type === "DISPLAY_ELEMENT")?.id || -1,
        element_id: register.currentStorageItem?.id,
        option_id: idDisplayOption,
        is_active: true,
        sub_type: "DISPLAY_ELEMENT",
        category: "NATIONAL"
      })
    }
    if(idItemTypeOption){
      moduleOptions.push({
        id: register.currentStorageItem?.module_options?.find(el => el.sub_type === "TYPE_ELEMENT")?.id || -1,
        element_id: register.currentStorageItem?.id,
        option_id: idItemTypeOption,
        is_active: true,
        sub_type: "TYPE_ELEMENT",
        category: "NATIONAL"
      })
    }
    if(idUmOption){
      moduleOptions.push({
        id: register.currentStorageItem?.module_options?.find(el => el.sub_type === "UM_ELEMENT")?.id || -1,
        element_id: register.currentStorageItem?.id,
        option_id: idUmOption,
        is_active: true,
        sub_type: "UM_ELEMENT",
        category: "NATIONAL"
      })
    }
    return moduleOptions
  }
  const onFinishForm = async (values: any) => {
    const registerOptions = values.registerOptions || [];
    const sellTaxes = getFormTaxes({...values},"sell")
    const purchaseTaxes = getFormTaxes({...values},"purchase")
    const otherValues = getOtherValues({...values})
    const prices = getPrices({...values},registerOptions)
    const moduleElementOptions = getModuleElementOptions({...values})
    const module_options = [...moduleElementOptions,...sellTaxes,...purchaseTaxes]
    const isFixedAsset = values.register_type === "FIXED_ASSET"
    const primaryImage = (values.images || []).find((img: any) => img.is_primary) || (values.images || [])[0]
    const primaryUrl = primaryImage?.file_url || values.image || ""

    const storageElement:Partial<TStorageItemRS> = {
      company_id:company.current?.id,
      custom_id:values.custom_id,
      barcode:values.barcode,
      description:values.description,
      sell_discount: values.sell_discount ?? 0,
      purchase_discount: values.purchase_discount ?? 0,
      min_quantity: isFixedAsset ? 0 : (values.min_quantity ?? 0),
      is_traceable: values.register_type === "SERVICE" ? false : (isFixedAsset ? (values.is_traceable !== undefined ? Boolean(values.is_traceable) : true) : Boolean(values.is_traceable)),
      name:values.name,
      purchase_item: isFixedAsset ? true : registerOptions.join("-").includes("PURCHASE"),
      sell_item: isFixedAsset ? false : registerOptions.join("-").includes("SALE"),
      sku:values.sku,
      location:values.location,
      is_active:true,
      image_mini: values.image_mini || primaryUrl,
      image: primaryUrl,
      images: values.images || [],
      company_uid:company.current?.uid || "",
      display:values.display || availablePresentation?.key || "UND",
      sell_price:values.sell_price,
      purchase_price:values.purchase_price,
      quantity: 0,
      register_type:values.register_type,
      measure_unit:values.measure_unit || "UN",
      category:values.category || availableCategory?.key || "VRS",
      parent_element_id: values.parent_element_id,
      conversion_factor: values.conversion_factor,
      module_options: module_options,
      prices: prices,
      other_values: otherValues,
    }
    console.log("Storage Item:", storageElement)
    let itemResponse
    setSpinning(true)
    if(mod === modules.RegisterStorageItem){
      //Incluir almacen por defecto
      const defaultStore = store.list.find(el => el.is_default === true)
      storageElement.inventory = defaultStore ? [{
        uid:defaultStore.uid,
        id:defaultStore.id,
        quantity:0,
        reserved:0
      }] : []
      //Añadir los demas valores que son opciones de los modulos como register_type y UM
      if(values.register_type === "SERVICE"){
        storageElement.display = "N/A"
        storageElement.location = "N/A"
        storageElement.measure_unit = "UN"
        storageElement.sell_item = registerOptions.join("-").includes("SALE")
        storageElement.purchase_item = registerOptions.join("-").includes("PURCHASE")
        storageElement.inventory = []
      }
      itemResponse = await securePost('/inventory/item/create-item',{
        storageElement,
        company:company.current?.uid,
        uidCompany:company.current?.uid,
        module:config.module
      })
    }
    if(mod === modules.EditStorageItem){
      storageElement.id = currentStorageItem.id
      itemResponse = await securePost('/inventory/item/update-item',{
        storageElement,
        company:company.current?.uid,
        uidCompany:company.current?.uid,
        uidItem:currentStorageItem.uid,
        module: config.module
      })
    }
    setSpinning(false)
    if(itemResponse.status === 200){
      setInitialDataForm(toDataForm({}))
      form.resetFields()
      mutate(key => Array.isArray(key) && key[0] === '/inventory/item/get-items', undefined, { revalidate: true })
      if(mod === modules.EditStorageItem){
        updateRegister({currentStorageItem:undefined})
        history.push(contentPath[modules.StorageItemList])
      }else{
        setOpenSuccess(true)
      }
    }else{
      console.log("Error al registrar el item:",itemResponse)
      fail(itemResponse.message || "Error al ejecutar la operación, por favor intente de nuevo.")
    }
    console.log(values)
  }

  const createNewItem = () =>{
    setOpenSuccess(false)
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const fail = (message:string) => {
    messageApi.open({
      type: 'error',
      content: message,
    });
  };
  
  const onChangeCheckbox:CheckboxGroupProps["onChange"] = (list) => {
    setCheckedList(list);
    form.setFieldsValue({ registerOptions: list });
  }
  const isEdit = mod === modules.EditStorageItem
  
  const handleGoBack = () => {
    updateRegister({currentStorageItem:undefined})
    history.push(contentPath[modules.StorageItemList])
  }
  return (
    <div className="container-fluid">
      {contextHolder}
        <Modal
          title={<div style={{ textAlign: "center" }}>El proceso se ejecutó de forma exitosa</div>}
          maskClosable={false}
          style={{maxWidth:400}}
          okText="Si"
          cancelText="No"
          open={openSuccess}
          onCancel={()=>{
            setOpenSuccess(false);
            updateConfig({module:modules.StorageItemList});
            history.push(contentPath[modules.StorageItemList])
          }}
          onOk={createNewItem}>
            <p>¿Desea agregar un nuevo item?</p>
        </Modal>
        <Spin size="large" tip="Cargando..." fullscreen spinning={spinning} />
        <div style={{marginBottom:"1.5rem",alignItems:"center",justifyContent:"space-between",display:"flex"}}>
          <h1 className="title-content">{title}</h1>
        </div>
        <div className="card shadow" style={{marginBottom:"1.5rem"}}>
          <div className="card-header" style={{paddingTop:"1rem"}}>
            <Row align="middle" justify="space-between">
              <Col flex="auto">
                <Space align="center">
                  {isEdit && <Button icon={<RollbackOutlined />} onClick={handleGoBack} />}
                  <h6 className="font-weight-bold text-primary" style={{margin:0}}>Datos de registro</h6>
                </Space>
              </Col>
              <Col>
                {showHeader && currentStorageItem?.uid &&
                  <Button type="dashed" htmlType="button" onClick={()=>updateRegister({showInventory:true})}>Existencias</Button>}
              </Col>
            </Row>
          </div>
          <div className="card-body">
            <Form
              form={form}
              layout="vertical"
              name="create-register"
              preserve={true}
              scrollToFirstError={{ block: 'end', focus: true }}
              style={{ maxWidth: '800px', margin: '0 auto' }}
              initialValues={initialDataForm}
              onFinish={onFinishForm}
            >
              {/* Sección 1: Datos básicos */}
              <h5 style={{marginLeft:"8.3333%",marginBottom:"0.5em",fontWeight:500,fontSize:"1rem"}}>Datos Básicos</h5>
              <Row gutter={[10, 10]}>
                <Col xs={24} sm={{span:10,offset:2}}>
                  <Form.Item
                    label="Tipo de registro"
                    name="register_type"
                    rules={[{ required: true, message: 'Por favor selecciona el tipo de registro' }]}
                  >
                    <Select
                      placeholder="Selecciona tipo"
                      disabled={mod === modules.EditStorageItem}
                      onChange={(val) => {
                        if (val === "FIXED_ASSET") {
                          form.setFieldsValue({ is_traceable: true });
                        } else if (val === "PRODUCT") {
                          form.setFieldsValue({
                            is_traceable: mod === modules.EditStorageItem ? Boolean(currentStorageItem?.is_traceable) : false,
                            registerOptions: checkedList
                          });
                        } else if (val === "SERVICE") {
                          form.setFieldsValue({
                            is_traceable: false,
                            registerOptions: checkedList
                          });
                        }
                      }}
                    >
                      {
                        availableItemTypes.map(el => <Option key={el.id} value={el.key}>{el.string_value}</Option>)
                      }
                    </Select>
                  </Form.Item>
                </Col>
                {(register_type === "PRODUCT" || register_type === "SERVICE") && <Col xs={24} sm={{span:10}}>
                  <Form.Item
                    label="Opciones de registro"
                    name="registerOptions"
                    initialValue={checkedList}
                    rules={[{ required: true, message: 'Por favor selecciona una opción' }]}
                  >
                    <Checkbox.Group options={checkboxOptions} value={checkedList} onChange={onChangeCheckbox}></Checkbox.Group>
                  </Form.Item>
                </Col>}
              </Row>
              {register_type === "PRODUCT" && <RegisterStorageItemForm form={form} getFormTaxes={getFormTaxes} />}
              {register_type === "SERVICE" && <RegisterServiceForm form={form} getFormTaxes={getFormTaxes}/>}
              {register_type === "FIXED_ASSET" && <RegisterFixedAssetForm form={form} getFormTaxes={getFormTaxes}/>}
            </Form>
          </div>
        </div>
        <div
          style={{
            position: "sticky",
            bottom: 0,
            background: "#fff",
            padding: "16px",
            textAlign: "right",
            boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
            zIndex: 10,
            borderRadius: "8px 8px 0 0",
          }}
        >
          <Space>
            <Popconfirm
              title="Por favor confirme la acción"
              description={mod===modules.EditStorageItem?"Si ha realizado cambios, no se guardarán":"El registro no será creado"}
              okText="Confirmar"
              cancelText="cancelar"
              onConfirm={()=>{history.push(contentPath[modules.StorageItemList]);updateRegister({currentStorageItem:undefined})}}>
              <Button type="default" disabled={!register_type} htmlType="button">Cancelar</Button>
            </Popconfirm>
            <Popconfirm
              title="Por favor confirme la acción"
              description={mod===modules.EditStorageItem?"El registro se actualizará con la nueva información":"El registro será creado"}
              okText="Confirmar"
              cancelText="cancelar"
              okButtonProps={{htmlType:"submit",form:"create-register"}}>
              <Button type="primary" disabled={!register_type} htmlType="button">Guardar</Button>
            </Popconfirm>
          </Space>
        </div>
        <InventoryModalData inventoryData={register.currentStorageItem?.inventory || []}></InventoryModalData>
    </div>
  )
}

export default RegisterStorageElement